import { OLD_SITE_VIDEO } from 'src/environments/environment.local';

export const menu = {
  primary: [
    {
      icon: 'fas fa-tachometer-alt',
      internal: true,
      link: '/dashboard',
      name: 'menu.dashboard',
      showAnonymous: false,
      showLogged: true,
      subMenu: null,
    },
    {
      icon: 'fas fa-search',
      isOpen: false,
      name: 'menu.browse',
      showAnonymous: true,
      showLogged: true,
      subMenu: [
        {
          icon: 'fas fa-video',
          internal: false,
          link: OLD_SITE_VIDEO,
          name: 'menu.motion',
        },
        {
          icon: 'fas fa-chalkboard-teacher',
          internal: false,
          link: OLD_SITE_VIDEO + '/fr/coaching',
          name: 'menu.coaching',
        },
        {
          icon: 'fas fa-chalkboard-teacher',
          internal: false,
          link: OLD_SITE_VIDEO + '/fr/workout',
          name: 'menu.workout',
        },
      ],
    },

  ],
  secondary: [
    {
      icon: 'fas fa-door-open',
      internal: true,
      link: 'get-started',
      name: 'menu.getStarted',
      showAnonymous: true,
      showLogged: true,
      subMenu: null,
    },
    {
      icon: 'fas fa-biking',
      internal: true,
      link: 'compatibility',
      name: 'menu.equipment',
      showAnonymous: true,
      showLogged: true,
      subMenu: null,
    },
    {
      icon: 'fas fa-dollar-sign',
      internal: true,
      link: 'home',
      name: 'menu.pricing',
      scrollTo: 'pricing',
      showAnonymous: true,
      showLogged: true,
      subMenu: null,
    },
  ],
};
